import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";
import getUserSlice from "./userBlockService";
// import createUser from "./userBlockService";
// import getUser from "./userBlockService";

const initialState = {
  users: [],
  isLoading: false,
  isError: false,
  isSuccess: false,
  errorMessage: "",
};

export const createUserData = createAsyncThunk(
  "users/createuser",
  async (user, thunkAPI) => {
    try {
      // console.log("user", user);
      return await getUserSlice.createUser(user);
    } catch (error) {
      console.log(error.response);
      const detail =
        (error.response && error.response.data && error.response.data.data) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(detail);
    }
  }
);

export const fetchUser = createAsyncThunk(
  "users/fetchUser",
  async (thunkAPI) => {
    try {
      return await getUserSlice.getUser();
    } catch (error) {
      const detail =
        (error.response && error.response.data && error.response.data.data) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(detail);
    }
  }
);

export const userBlockSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createUserData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createUserData.fulfilled, (state,action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.users = action.payload;
      })
      .addCase(createUserData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(fetchUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.users = action.payload;
      })
      .addCase(fetchUser.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      });
  },
});

export default userBlockSlice.reducer;
